export const initialState = {
    loading: [],
};
